import { ExpertisesCovered, StatesCovered } from "#/types";
import ApiService from "../apiService";

export default class AccreditedDentalOffices extends ApiService {
  constructor(plan: string) {
    super(`/accredited-dental-offices/${plan}`, "v2");
  }

  getStates(): Promise<StatesCovered[]> {
    const headers = {
      headers: {
        Accept: "application/json",
      },
    };
    return this.get(`/state`, headers);
  }

  getStateCities(stateAcronym: string): Promise<string[]> {
    const headers = {
      headers: {
        Accept: "application/json",
      },
    };
    return this.get(`/city?state=${stateAcronym}`, headers);
  }

  getNeighborhoods(stateAcronym: string, city: string): Promise<string[]> {
    const headers = {
      headers: {
        Accept: "application/json",
      },
    };
    return this.get(
      `/neighborhood?state=${stateAcronym}&city=${city}`,
      headers
    );
  }

  getExpertises(
    stateAcronym: string,
    city: string
  ): Promise<ExpertisesCovered[]> {
    const headers = {
      headers: {
        Accept: "application/json",
      },
    };
    return this.get(`?state=${stateAcronym}&city=${city}`, headers);
  }
}
